import React, { useEffect, useState } from "react";
import { SectionTitle } from "../SectionTitle";
import { Box, Fab, Grid } from "@mui/material";
import SearchProducts from "../../containers/Catalogo/SearchProducts";
import CreationCard from "./CreationCard";
import mockCreations from "./mockCreations";
import AddIcon from "@mui/icons-material/Add";
import CreationDetailModal from "./CreationDetailModal";
const Comunity = () => {
  const [results, setResults] = React.useState([]);
  const [creations, setCreations] = useState([]);
  const [selectedCreation, setSelectedCreation] = useState(null);
  useEffect(() => {
    setCreations(mockCreations);
  }, []);
  return (
    <Box
      component={"section"}
      sx={{
        padding: 4,
        backgroundColor: "#FBFAFF",
      }}
      className='trending'
    >
      <SectionTitle
        subTitle='Comunidad de creaciones MerryColor'
        body='Inspírate con las creaciones de nuestra comunidad y comparte tus propias obras. Juntos, hacemos florecer la creatividad. 🌸✨'
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SearchProducts results={results} setResults={setResults} />
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        {creations.map((creation) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={creation.id}>
            <CreationCard
              data={creation}
              onClick={() => setSelectedCreation(creation)}
            />
          </Grid>
        ))}
      </Grid>
      <Fab
        color='primary'
        aria-label='add'
        sx={{ position: "fixed", bottom: 32, right: 32 }}
        onClick={() => {
          // abrir modal de creación o redireccionar
          console.log("Abrir formulario de subida");
        }}
      >
        <AddIcon />
      </Fab>

      {selectedCreation && (
        <CreationDetailModal
          open={Boolean(selectedCreation)}
          onClose={() => setSelectedCreation(null)}
          creation={selectedCreation}
        />
      )}
    </Box>
  );
};

export default Comunity;
